import { render, staticRenderFns } from "./Findings.vue?vue&type=template&id=f4f2937c&scoped=true"
import script from "./Findings.vue?vue&type=script&lang=js"
export * from "./Findings.vue?vue&type=script&lang=js"
import style0 from "./Findings.vue?vue&type=style&index=0&id=f4f2937c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f2937c",
  null
  
)

export default component.exports